export enum ButtonType {
  SUCCESS = 'success',
  CANCEL = 'cancel',
  SUBMIT = 'submit',
  DEFAULT = 'default'
}